import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useLayoutEffect } from 'react';
import { onLanguageChanged, queryClient } from './hooks';
import { setBookitoApiJwt, setBookitoApiLanguage } from './queries/api';
import { SupportedLanguages } from './types';

type BookitoProviderProps = {
  jwt?: string;
  language?: SupportedLanguages;
};

export const BookitoProvider: React.FC<BookitoProviderProps> = ({ children, jwt, language }) => {
  useEffect(() => {
    setBookitoApiJwt(jwt);
  }, [jwt]);

  setBookitoApiLanguage(language);

  useLayoutEffect(() => {
    const { isSetFirstTime } = setBookitoApiLanguage(language);
    if (!isSetFirstTime) {
      onLanguageChanged();
    }
  }, [language]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
